const items = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '通过多重安全检测认证，不含恶意代码和捆绑软件，全面保障用户设备与隐私安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速体验',
    desc: '全新播放引擎，视频加载速度提升40%。智能CDN加速，全国多节点覆盖，播放流畅不卡顿。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台覆盖',
    desc: '支持Android、iOS手机和平板设备，电脑端网页版同步可用。一套账号，多端无缝切换。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    desc: '7×24小时在线客服支持，快速响应用户反馈。定期更新迭代，持续优化产品体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            核心优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            四大核心能力，定义优质观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {items.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl border border-secondary-100 p-6 text-center transition-all hover:border-primary-200">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${f.icon} text-accent-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}